import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/auth";
import { useListManager } from "../../contexts/list.manager";
import { useTranslation } from "react-i18next";
import "./SignOutButton.css";

const SignOutButton = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const { closeForm } = useListManager();
  const { t } = useTranslation();

  function SignOut() {
    closeForm();
    signOut();
    navigate("/login");
  }

  return (
    <span className="sign-out-button" onClick={SignOut}>
      {t('common.signOut')}
    </span>
  );
};

export default SignOutButton;
